import { Pipe, PipeTransform } from '@angular/core';
import { AgentOperatingModeEnum } from '@zaoblako/shared/modules/ai/enums/agent-operating-mode.enum';
import { AgentOperatingModeEnumI18n } from '@zaoblako/shared/modules/ai/i18n/agent-operating-mode-enum.i18n';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';

@Pipe({
  name: 'agentOperatingModeName',
  standalone: true
})
export class AgentOperatingModeNamePipe implements PipeTransform {
  public transform(mode: AgentOperatingModeEnum): string {
    return AgentOperatingModeEnumI18n[I18nLocalesEnum.RU_RU][mode] ?? '';
  }
}
